import { useContext } from 'react'
import { Address } from '../model'
import { TibiContext } from '../context/ContextProvider'

export const useLocalAddress = () => {
    const { value, setValue, remove } = useContext(TibiContext)

    const addressList: Address = value.address || null
    const getLocalAddress = () => {
        return addressList
    }

    const setLocalAddress = (data: Address[]) => {
        setValue({ ...value, address: data })
    }

    const updateLocalAddress = (address: Address) => {
        setValue({ address })
    }

    const removeLocalAddress = () => {
        remove()
    }
    return { addressList, getLocalAddress, setLocalAddress, updateLocalAddress, removeLocalAddress }
}
